import { Component, Inject, forwardRef, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { AppComponent } from './app.component';
import { PadraoService } from './service/padrao.service';
import { ObservableLotacao, bObservableUsuario } from './util/observable-util';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from '../../node_modules/rxjs';
import { ConfirmationService, Message, Header } from 'primeng/primeng';
import { JwtHelper } from "angular2-jwt";
import { ObservableBlockPanelDoc } from './util/observable-util';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrls: ["app.topbar.component.css"]
})

export class AppTopBar {

    timeToExpireToken: any = -1;
    tempoExpFormatado: any = "00:00:00";
    userInfo: any;
    contagemTokenIniciada: any = false;
    dialogEmitted: boolean = false;
    id_lotacao: any = '';
    msgs: Message[] = [];
    listaLotacao: any[] = [];
    ticks: any = 0;
    confirmacao: ConfirmationService;
    usuarioSimulado: string = null;
    cpfSimulado: string = null;
    listaNotificacao: any[] = [];
    novasNotificacoes: number = 0;
    semNotificacoes: boolean = false;
    isCarregouPagina: boolean;

    @Output() emitDialog = new EventEmitter<boolean>();

    constructor(
        @Inject(forwardRef(() => AppComponent)) public app: AppComponent,
        private service: PadraoService,
        private lotacaoService: ObservableLotacao,
        private observableUser: bObservableUsuario,
        private cdRef: ChangeDetectorRef,
        private router: Router,
        private jwtHelper: JwtHelper,
        private observableUtilPanelDoc: ObservableBlockPanelDoc,
    ) {

        this.lotacaoService.setLotacao(Object.assign({}, null, { isLoaded: false }));
        
        if (localStorage.getItem("token") != null && !window.frameElement) {
            this.service.Permissoes();
            this.observableUser.getValue.subscribe(data => {
                if (data !== "" && data) {
                    if (this.contagemTokenIniciada == false && !this.jwtHelper.isTokenExpired(localStorage.getItem("token"))) {
                        this.obterTimeToExpireToken();
                        this.contagemToken();
                    }
                    this.userInfo = data.obj;
                    this.listaLotacao = this.userInfo.lotacaoDTO;
                    if (this.listaLotacao.every(x => x.nome == 'Lotação Pública')) {
                        localStorage.setItem('path', this.userInfo.lotacaoDTO[0].anexoLotacao[0].nomeUpload);
                        this.service.ObterLogoLotacao('acessos', this.userInfo.lotacaoDTO[0].anexoLotacao[0].nomeUpload).subscribe(data => {
                            const objetoURL = window.URL.createObjectURL(this.b64toFile(data, null, "image/png"))
                            document.getElementById('imagemLogoLotacao').style.backgroundImage = 'url(' + objetoURL + ')';
                        });
                        localStorage.setItem('lotacao', this.userInfo.lotacaoDTO[0].id);
                    } else if (localStorage.getItem('lotacao') == '' || localStorage.getItem('lotacao') == null) {
                        this.id_lotacao = this.userInfo.lotacaoDTO[0].id;
                        localStorage.setItem('path', this.userInfo.lotacaoDTO[0].anexoLotacao[0].nomeUpload);
                        this.service.ObterLogoLotacao('acessos', this.userInfo.lotacaoDTO[0].anexoLotacao[0].nomeUpload).subscribe(data => {
                            const objetoURL = window.URL.createObjectURL(this.b64toFile(data, null, "image/png"))
                            document.getElementById('imagemLogoLotacao').style.backgroundImage = 'url(' + objetoURL + ')';
                        });
                        localStorage.setItem('lotacao', this.id_lotacao);
                    } else {
                        this.id_lotacao = localStorage.getItem('lotacao');
                        const lot = this.listaLotacao.find(x => x.id == this.id_lotacao);
                        this.service.ObterLogoLotacao('acessos', lot.anexoLotacao[0].nomeUpload).subscribe(data => {
                            const objetoURL = window.URL.createObjectURL(this.b64toFile(data, null, "image/png"))
                            document.getElementById('imagemLogoLotacao').style.backgroundImage = 'url(' + objetoURL + ')';
                        });
                    }
                    this.lotacaoService.setLotacao(Object.assign({}, this.listaLotacao.find(x => x['id'] == localStorage.getItem('lotacao')), { isLoaded: true }));

                    this.listaLotacao = this.listaLotacao.filter(x => x.nome !== 'Lotação Pública');

                    this.service.ListarTodos('simularUsuario', { cpf: this.userInfo.cpf }).subscribe(dadosDeSimulacao => {
                        const possuiUsuarioParaSimulacao = dadosDeSimulacao.length > 0;
                        const construirDadosCabeçalho = possuiUsuarioParaSimulacao ?
                            this.userInfo.nome === dadosDeSimulacao[0].usuario1.nome : false;

                        if (!possuiUsuarioParaSimulacao) {
                            localStorage.removeItem('simulacaoEmAndamento');
                        }

                        if (possuiUsuarioParaSimulacao && construirDadosCabeçalho) {
                            this.usuarioSimulado = 'Usuário Simulado: ' + dadosDeSimulacao[0].usuario.nome;
                            this.cpfSimulado = dadosDeSimulacao[0].usuario.cpf;
                        }
                    });

                }
            });
        }

        this.router.events.subscribe(x => {
            if (x instanceof NavigationStart) {
                this.listarNotificacoes();
            }
        });
    }

    listarNotificacoes() {
        this.id_lotacao = !this.id_lotacao ? + localStorage.getItem('lotacao') : this.id_lotacao;
        this.service.ListarNotificacoes(this.id_lotacao).subscribe(x => {
            this.novasNotificacoes = 0;
            this.semNotificacoes = !x.length && this.isCarregouPagina;

            if (localStorage.getItem('dataNotificacao') == null) {
                localStorage.setItem('dataNotificacao', new Date().toString());
            }
            const dataNotificacao = new Date(localStorage.getItem('dataNotificacao')).toDateString();
            if (dataNotificacao == new Date().toDateString()) {
                const listados = localStorage.getItem('notificacao') ? localStorage.getItem('notificacao').split(',') : [];
                this.listaNotificacao = x.map(y => {
                    y.cor = "";
                    if (y.isNovo) {
                        y.isNovo = !listados.some(z => z == y.id);
                        this.novasNotificacoes = y.isNovo ? this.novasNotificacoes + 1 : this.novasNotificacoes;
                    }

                    y.cor = y.isNovo ? "#0e3e67" : "#808080";
                    y.background = y.isNovo ? "#ffffff" : "#ededed";
                    return y;
                });
            } else {
                localStorage.removeItem('notificacao');
                localStorage.setItem('dataNotificacao', new Date().toString());
                this.listaNotificacao = x.map(y => {
                    if (y.isNovo) {
                        this.novasNotificacoes = this.novasNotificacoes + 1;
                    }

                    y.cor = y.isNovo ? "#0e3e67" : "#808080";
                    y.background = y.isNovo ? "#ffffff" : "#ededed";
                    return y;
                });
            }

            this.semNotificacoes = this.listaNotificacao.length === 0;
        });
    }

    contagemToken() {
        this.contagemTokenIniciada = true;
        Observable.interval(1000)
            .subscribe(i => {
                if (localStorage.getItem("timeExpToken") && !this.jwtHelper.isTokenExpired(localStorage.getItem("token"))) {
                    this.timeToExpireToken = localStorage.getItem("timeExpToken");
                    this.timeToExpireToken = +this.timeToExpireToken + 60;
                    localStorage.removeItem("timeExpToken");
                }
                if (this.jwtHelper.isTokenExpired(localStorage.getItem("token")) && this.timeToExpireToken == 0) {
                    this.contagemTokenIniciada = false;
                    this.emitDialog.emit(true);
                } else {
                    if (this.timeToExpireToken > 0) {
                        this.timeToExpireToken = this.timeToExpireToken - 1;
                        const date = new Date(null);
                        date.setSeconds(this.timeToExpireToken);
                        this.tempoExpFormatado = date.toISOString().substr(11, 8);
                    }
                }
            });
    }

    obterTimeToExpireToken() {
        this.service.ObterTokenDecodificado().subscribe(time => {
            localStorage.setItem("timeExpToken", time);
        });
    }

    reiniciarContagemToken() {
        this.obterTimeToExpireToken();
        this.contagemToken();
    }

    onChangeLotacao(lotacao: any): void {
        localStorage.setItem('lotacao', this.id_lotacao);
        this.router.navigate(['../']);
        this.lotacaoService.setLotacao(Object.assign({}, this.listaLotacao.find(x => x['id'] == localStorage.getItem('lotacao')), { isLoaded: true }))
        var lot = this.listaLotacao.find(x => x.id == this.id_lotacao);
        localStorage.setItem('path', lot.anexoLotacao[0].nomeUpload);
        this.service.ObterLogoLotacao('acessos', localStorage.getItem("path")).subscribe(data => {
            var objetoURL = window.URL.createObjectURL(this.b64toFile(data, null, "image/png"))
            document.getElementById('imagemLogoLotacao').style.backgroundImage = 'url(' + objetoURL + ')';
        });
        this.service.ListarTodos('fila-notificacao', { id_lotacao_atual: this.id_lotacao }).subscribe(x => {
            if (localStorage.getItem('dataNotificacao') == null) {
                localStorage.setItem('dataNotificacao', new Date().toString());
            }
            var dataNotificacao = new Date(localStorage.getItem('dataNotificacao')).toDateString();
            if (dataNotificacao == new Date().toDateString()) {
                var listados = localStorage.getItem('notificacao') ? localStorage.getItem('notificacao').split(',') : [];
                this.listaNotificacao = x.map(y => {
                    if (y.isNovo) {
                        y.isNovo = !listados.some(z => z == y.id);
                        this.novasNotificacoes = y.isNovo ? this.novasNotificacoes + 1 : this.novasNotificacoes;
                    }
                    return y;
                });
            } else {
                localStorage.removeItem('notificacao');
                localStorage.setItem('dataNotificacao', new Date().toString());
                this.listaNotificacao = x.map(y => {
                    if (y.isNovo) {
                        this.novasNotificacoes = this.novasNotificacoes + 1;
                    }
                    return y;
                });
            }
        });
    }

    getItemBy(arr: any, filter: any) {
        if (arr == null)
            return "";
        let ret = arr.find(item => {
            let select = true;
            Object.keys(filter).forEach(fkey => {
                if (select && item[fkey] != filter[fkey])
                    select = false;
            });
            return select;
        });
        return ret ? ret : "";
    }

    setStyles() {
        let styles = {
            'display': 'inline-block',
            'vertical-align': 'middle',
            'width': '180px',
            'height': '70px',
            'background': 'top left no-repeat',
            'background-size': '130px 55px',
            'margin-left': '50px'
        };
        return styles;
    }

    b64toFile(b64Data, filename, contentType) {
        var sliceSize = 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);

            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        var file = new File(byteArrays, filename, { type: contentType });
        return file;
    }

    LogoutSimulado() {
        this.service.EncerrarSimulacao('simularUsuario', this.userInfo.id)
            .subscribe(success => {
                localStorage.removeItem('lotacao')
                localStorage.removeItem('simulacaoEmAndamento');
                window.location.href = `http://${window.location.host}/`;
            })
    }

    ZeraNotificacao() {
        var retorno = this.listaNotificacao.map(x => {
            if (x.isNovo) {
                return x.id;
            }
        })
        if (retorno.some(x => x !== undefined) && this.novasNotificacoes != 0) {
            if (localStorage.getItem('notificacao') == null) {
                localStorage.setItem('notificacao', retorno.filter(x => x != undefined).toString());
            } else {
                const salvarLocal = localStorage.getItem('notificacao') + ',' + retorno.filter(x => x != undefined).toString()
                localStorage.setItem('notificacao', salvarLocal);
            }
            this.novasNotificacoes = 0;
            this.cdRef.detectChanges();
        }
        this.isCarregouPagina = true;
    }

    LeuNotificacao() {
        if (this.listaNotificacao.some(x => x.cor != '#808080')) {
            this.listaNotificacao = this.listaNotificacao.map(x => {
                x.cor = '#808080';
                x.background = "#ededed";
                return x;
            })
            this.cdRef.detectChanges();
        }
    }

    UrlNotificacao(link) {
        return window.location.href = link;
    }

    excluirNoficacao(val) {
        this.observableUtilPanelDoc.setBlockedPanel(true);
        this.service.AtualizarById('fila-notificacao', val.fila_notificacao_usuario[0].id).subscribe(
            sucess => {
                const index = this.listaNotificacao.map(x => x.id).indexOf(val.id);
                this.listaNotificacao.splice(index, 1);
                this.semNotificacoes = this.listaNotificacao.length === 0;
                this.cdRef.detectChanges();
                this.observableUtilPanelDoc.setBlockedPanel(false);
            },
            err => {
                this.observableUtilPanelDoc.setBlockedPanel(false);
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/app.topbar.component.ts